import API from "./axios";

/**
 * Phase 36da.99.bp — Vendor Ledger API client.
 *
 * Returns:
 *   {
 *     opening: number,
 *     closing: number,
 *     entries: [
 *       { id, entryDate, entryType, refType, refId,
 *         particular, debit, credit, balance, narration }
 *     ],
 *     vendorId: number
 *   }
 */
const vendorLedgerApi = {
  ledger: (params) => API.get("/vendor-ledger", { params }),  // { vendorId, from?, to? }
};

export default vendorLedgerApi;